module.exports = __webpack_public_path__ + "static/media/OurStory-PinkWaveMobile.4bea4b9b.svg";